export default __webpack_public_path__ + "static/hire_android_banner-ea91f96630c5be23a7bcd15eb669b0f5.webp";